<template>
  <div id="app">
    <section id="team" class="team">
      <div class="team-decor">
        <div class="team-circle1"><img :src='"../assets/images/team1.png"' alt=""></div>
        <div class="team-circle2"><img :src='"../assets/images/team3.png"' alt=""></div>
        <div class="team-circle3"><img :src='"../assets/images/team.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-sm-12">
            <h2 class="title"><span>livetrackz team</span></h2>
          </div>
          <div class="col-sm-12">
            <div>
              <carousel :className='"team-carousel"'
                        :loop=false
                        :margin=30
                        :items=2
                        :nav=false
                        :dots=true
                        :dotsEach=true
                        :autoplay=false
                        :responsive="{0:{items:1,margin:5},600:{items:1,margin:5},768:{items:2},992:{items:3},1000:{items:3}}">
                  <div class="team-item">
                    <div class="team-block">
                      <div class="team-box">
                        <div class="team-avtar">
                          <img :src='"../assets/images/avtar/1.jpg"' alt="">
                        </div>
                        <div class="team-text">
                          <h3>Deji Toki</h3>
                          <h6>Creator, IOS Dev</h6>
                        </div>
                        <div class="overlay">
                          <ul class="team-social">
                            <li><a href="https://www.linkedin.com/in/deji-toki-77539a152/" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                            <!--<li><a href="https://twitter.com/DaveDeji" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>-->
                            <li><a href="https://www.instagram.com/davedeji/" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href="https://www.facebook.com/deji.toki" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="team-item">
                    <div class="team-block">
                      <div class="team-box">
                        <div class="team-avtar">
                          <img :src='"../assets/images/avtar/15.jpg"' alt="">
                        </div>
                        <div class="team-text">
                          <h3>Knowledge majoni</h3>
                          <h6>UX Design, Drummer</h6>
                        </div>
                        <div class="overlay">
                          <ul class="team-social">
                            <li><a href="https://www.behance.net/knowledgembfd7" target="_blank"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
                            <li><a href="https://ca.linkedin.com/in/knowledge-majoni-4333b3167" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                            <li><a href="http://www.knowledgemajoni.com" target="_blank"><i class="fa fa-globe" aria-hidden="true"></i></a></li>
                            <li><a href="https://www.instagram.com/knowledge_majoni/" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'Team'
}
</script>



// WEBPACK FOOTER //
// src/components/team.vue